import { useQuery } from '@tanstack/react-query';
import {
  uptimeService,
  type UptimeHistoryResponse,
  type UptimeRange,
} from '@/services/uptime/uptime.service';

export function useUptimeHistory(
  subscriptionId: string | undefined,
  range: UptimeRange,
) {
  return useQuery<UptimeHistoryResponse>({
    queryKey: ['uptime-history', subscriptionId, range],
    queryFn: () => uptimeService.getHistory(subscriptionId!, range),
    enabled: !!subscriptionId,
    refetchInterval: 30_000,
  });
}
